export const COLORS = {
  primary: '#171E26',
  secondary: '#454D53',
  tertiary: '#747E7F',
  border: '#e2e2e2',
  borderGray: '#E8E9EA',
  borderDarkGray: '#D1D2D4',
  disabled: '#A2A5A8',
  lightGray: '#F7F8F9',
  lightGray200: '#F0F0F0',
  green: '#00A84D',
  green100: '#eaf8f2',
  blueGray: '#3D5066',
  white: '#ffffff',
  error: '#D84836',
  info: '#0C64CE',
  tableBackground: '#F7F8FC',
  table: 'rgba(0, 82, 189, 1)',
  lightGray100: '#f7f8f9',
  primary100: '#EAF8F2',
  primary500: '#1E9B6B',
  lineNormal: 'rgba(112, 115, 124, 0.22)',
  lineNeutral: 'rgba(112, 115, 124, 0.16)',
  lineBorder: 'rgba(23, 30, 38, 0.10)',
  labelAssistive: 'rgba(55, 56, 60, 0.28)',
  labelNormal: '#222',
  labelNeutral: '#616161',
  labelAlternative: 'rgba(55, 56, 60, 0.61)',
  labelStrong: '#000',
  labelDisable: 'rgba(55, 56, 60, 0.16)',
  orange: '#FB6400',
  backgroundNeutral: '#F5F5F5',
  interactionNeutral: '#989BA2',
  interactionDisable: '#F7F7F8',
  textPrimary: '#172626',
  textSecondary: 'rgba(23, 30, 38, 0.78)',
  textTetiary: 'rgba(23, 30, 38, 0.56)',
};
